export const getUsersUrl = (page, q) => {
  let url = '/users';
  let op = '?';

  if (page) {
    url = url.concat(`?page=${page}`);
    op = '&';
  }
  if (q) url = url.concat(`${op}q=${q}`);

  return url;
};

export const displayLabel = text => {
  return `${text}*`;
};
